import { WeekSelector } from 'components/navigation'
import { FC, ReactNode } from 'react'

interface Props {
  children?: ReactNode
  onWeekSelect: (startOfWeek: DateTime) => void
  selectedWeek: DateTime
  weekStartsOn: 'monday' | 'sunday'
}

export const WeekSelectorSubHeader: FC<Props> = ({
  children,
  onWeekSelect,
  selectedWeek,
  weekStartsOn,
}) => {
  return (
    <div className="z-20 flex flex-row items-center px-8 pt-6 pb-4">
      <WeekSelector
        onWeekSelect={onWeekSelect}
        selectedWeek={selectedWeek}
        variant="light"
        weekStartsOn={weekStartsOn}
      />
      <div className="flex flex-row items-center ml-auto">{children}</div>
    </div>
  )
}
